/**
 *
 * Countries
 *
 */

import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Breadcrumb, Layout, Card, Pagination } from "antd";
import LeadTable from "../../components/leadTable";
import india from "../../utils/images/india.svg";
// import SearchPlaces from '../../components/searchPlace'
const { Content } = Layout;

export function Lead() {
  const [page, setPage] = useState(1);

  const title = (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item href="/">
          <span>
            <img src={india} alt="india" style={{ height: 35, width: 35 }} />
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{/* <SearchPlaces /> */}</Breadcrumb.Item>
      </Breadcrumb>
    </div>
  );

  return (
    <div>
      <Helmet>
        <title>Zo Supply | Leads</title>
      </Helmet>

      <Content className="content">
        <Card
          title={title}
          extra={
            <Pagination
              total={4357}
              showTotal={total => `Total ${total} items`}
              pageSize={10}
              defaultCurrent={1}
              onChange={(page, pageSize) => setPage(page)}
            />
          }
        >
          <LeadTable page={page} />
        </Card>
      </Content>
    </div>
  );
}

export default Lead;
